<template>
  <div class="team-requests">
    <div class="team-requests__head">
      <feather-icon
        icon="RadioIcon"
        size="14"
        class="mr-50"
      />
      <span>Aguardando despacho</span>
      <b-spinner
        v-if="loading"
        small
        class="ml-50"
      />
    </div>

    <div
      v-if="!loading && !requests.length"
      class="team-requests__empty"
    >
      Nenhuma solicitação médica registrada nesta ocorrência.
    </div>

    <div
      v-else-if="!loading && !pending.length"
      class="team-requests__empty"
    >
      Nada pendente — o desfecho de cada solicitação está no Histórico de Decisões.
    </div>

    <ul
      v-else
      class="team-requests__list"
    >
      <li
        v-for="req in pending"
        :key="req.id"
        class="team-requests__item"
        :class="'team-requests__item--' + statusKey(req.status)"
      >
        <span class="team-requests__dot" />

        <div class="team-requests__body">
          <div class="team-requests__title">
            {{ req.team_type ? req.team_type.name : 'Tipo removido' }}
            <span
              v-if="req.dispatch_code"
              class="team-requests__code"
            >{{ req.dispatch_code.code }}</span>
            <span class="team-requests__status">{{ statusLabel(req) }}</span>
          </div>

          <div
            v-if="req.notes"
            class="team-requests__notes"
          >
            {{ req.notes }}
          </div>

          <div class="team-requests__meta">
            <feather-icon
              icon="UserIcon"
              size="10"
              class="mr-25"
            />
            {{ req.requested_by ? req.requested_by.name : '—' }}
            <span class="team-requests__sep">·</span>
            {{ req.created_at | trFormatDate }}
          </div>

        </div>

        <button
          v-if="canCancel"
          class="btn btn-sm btn-outline-danger team-requests__cancel"
          @click="$emit('cancel', req)"
        >
          Cancelar
        </button>
      </li>
    </ul>

    <div
      v-if="suggestedTypes && suggestedTypes.length"
      class="team-requests__suggested"
    >
      <feather-icon
        icon="HelpCircleIcon"
        size="11"
        class="mr-25"
      />
      Interrogatório sugeriu:
      <span
        v-for="(t, i) in suggestedTypes"
        :key="t.id"
      >
        {{ t.name }}<span v-if="i < suggestedTypes.length - 1">, </span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OccurrenceTeamRequests',

  filters: {
    trFormatDate(val) {
      if (!val) return '—'
      return new Date(val).toLocaleString('pt-BR', {
        day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit',
      })
    },
  },

  props: {
    requests: { type: Array, default: () => [] },
    suggestedTypes: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    canCancel: { type: Boolean, default: false },
  },

  computed: {
    pending() {
      return this.requests.filter(r => r.status === 1)
    },
  },

  methods: {
    statusKey(status) {
      return { 1: 'pending', 2: 'fulfilled', 3: 'cancelled' }[status] || 'pending'
    },

    statusLabel(req) {
      if (req.quantity > 1 && req.remaining < req.quantity) {
        return `faltam ${req.remaining}`
      }
      return 'pendente'
    },
  },
}
</script>

<style scoped>
.team-requests { border:1px solid #ebe9f1; border-radius:8px; background:#fff; margin-bottom:16px; }
.team-requests__head {
  display:flex; align-items:center; padding:8px 12px; border-bottom:1px solid #f2f0f7;
  font-size:11px; font-weight:700; letter-spacing:.04em; text-transform:uppercase; color:#6e6b7b;
}
.team-requests__empty { padding:14px 12px; font-size:12px; color:#b9b9c3; }
.team-requests__list { list-style:none; margin:0; padding:0; }
.team-requests__item { display:flex; align-items:flex-start; gap:8px; padding:10px 12px; border-bottom:1px solid #f7f6fb; }
.team-requests__item:last-child { border-bottom:0; }
.team-requests__dot { width:8px; height:8px; border-radius:50%; margin-top:5px; flex:0 0 8px; }
.team-requests__item--pending   .team-requests__dot { background:#ff9f43; }
.team-requests__item--fulfilled .team-requests__dot { background:#28c76f; }
.team-requests__item--cancelled .team-requests__dot { background:#b9b9c3; }
.team-requests__body { flex:1; min-width:0; }
.team-requests__title { font-size:13px; font-weight:600; color:#5e5873; }
.team-requests__item--cancelled .team-requests__title { text-decoration:line-through; color:#b9b9c3; }
.team-requests__code {
  display: inline-flex;
  align-items: center;
  margin-left: 6px;
  padding: 1px 7px;
  border-radius: 9px;
  font-size: 10.5px;
  font-weight: 700;
  background: #eceffd;
  color: #4c5eb5;
}
.dark-layout .team-requests__code { background: #1f2547; color: #a3b0ff; }
.team-requests__status { font-size:11px; font-weight:600; margin-left:6px; }
.team-requests__item--pending   .team-requests__status { color:#ff9f43; }
.team-requests__item--fulfilled .team-requests__status { color:#28c76f; }
.team-requests__item--cancelled .team-requests__status { color:#b9b9c3; }
.team-requests__notes { font-size:12px; color:#6e6b7b; margin-top:2px; }
.team-requests__meta { font-size:11px; color:#b9b9c3; margin-top:3px; }
.team-requests__sep { margin:0 4px; }
.team-requests__cancel { flex:0 0 auto; }
.team-requests__suggested { padding:8px 12px; border-top:1px dashed #ebe9f1; font-size:11px; color:#b9b9c3; }

.dark-layout .team-requests { background:#283046; border-color:#3b4253; }
.dark-layout .team-requests__head { color:#d0d2d6; border-color:#3b4253; }
.dark-layout .team-requests__title { color:#d0d2d6; }
.dark-layout .team-requests__item { border-color:#3b4253; }
.dark-layout .team-requests__suggested { border-color:#3b4253; }
</style>
